import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Check } from 'lucide-react';
import { PAYMENT_METHODS, BLOCK_LABELS } from './constants';

export default function SummaryCard({
  isManual,
  isSeries = false,
  locations, locationId, bookingDate, timeSlot, duration,
  sport, quantity, selectedCourts,
  unitPrice,
  grossTotal, discountAmount, discountType, discountValue, finalTotal, paymentMethod,
  blockLabel, blockReason,
  submitting, handleSubmit,
}) {
  const showFinancials = isManual || isSeries;
  return (
    <Card className="p-4 sticky top-4">
      <h3 className="text-lg font-bold uppercase mb-3">Summary</h3>
      <div className="text-sm space-y-1 mb-3">
        <p>📍 {locations.find((l) => l.id === locationId)?.name || '—'}</p>
        <p>📅 {bookingDate || '—'} · {timeSlot || '—'} · {duration}h</p>
        <p>🏸 {sport} × {quantity} court{quantity > 1 ? 's' : ''}</p>
        <p>{selectedCourts.length > 0
          ? selectedCourts.map((n) => `Court ${n}`).join(', ')
          : 'No court selected'}
        </p>
      </div>

      {showFinancials ? (
        <div className="text-sm space-y-1 border-t pt-3">
          {unitPrice ? (
            <div className="flex justify-between text-muted-foreground text-xs" data-testid="summary-rate-line">
              <span>Rate</span>
              <span>
                ${Number(unitPrice).toFixed(2)}/hr × {duration}h{quantity > 1 ? ` × ${quantity} courts` : ''}
              </span>
            </div>
          ) : null}
          <div className="flex justify-between"><span>{isSeries ? 'Per Booking Gross' : 'Gross'}</span><span>${grossTotal.toFixed(2)}</span></div>
          {discountAmount > 0 && (
            <div className="flex justify-between text-red-600">
              <span>Discount {discountType === 'percentage' ? `(${discountValue}%)` : ''}</span>
              <span>-${discountAmount.toFixed(2)}</span>
            </div>
          )}
          <div className="flex justify-between border-t pt-2 mt-2 font-bold text-lg">
            <span>{isSeries ? 'Per Booking Net' : 'Net Total'}</span>
            <span className="text-primary">${finalTotal.toFixed(2)}</span>
          </div>
          <p className="text-xs text-muted-foreground pt-1">
            {isSeries ? 'Series total is calculated on preview.' : <>To collect via <strong>{PAYMENT_METHODS.find((p) => p.value === paymentMethod)?.label}</strong></>}
          </p>
        </div>
      ) : (
        <div className="text-sm border-t pt-3">
          <p className="font-bold uppercase">Block</p>
          <p>{BLOCK_LABELS.find((b) => b.value === blockLabel)?.label}</p>
          {blockReason && <p className="text-xs text-muted-foreground italic mt-1">"{blockReason}"</p>}
        </div>
      )}

      <Button
        onClick={handleSubmit}
        disabled={submitting}
        className="w-full mt-4 btn-primary"
        data-testid="submit-btn"
      >
        {submitting ? 'Saving…' : (
          <span className="inline-flex items-center gap-1">
            <Check className="w-4 h-4" />
            {isManual && 'Save & Confirm'}
            {isSeries && 'Preview Series'}
            {!isManual && !isSeries && 'Block Court'}
          </span>
        )}
      </Button>
    </Card>
  );
}
